import React from 'react'
import { useSelector } from 'react-redux';
import { selectTranslations } from '../../config/i18n/slice';
import { Button, Divider } from 'semantic-ui-react';
import { useHistory } from "react-router";

const EmptyFilter = ({part=true, set=false}) => {
    const t = useSelector(selectTranslations);
    const history = useHistory();
  return (
    <div className="table-header-dashbaord team-filter filters">
    <Button.Group
      className="add-people-btn part"
      basic
      fluid
      size="medium"
    >
      <Button type="button" onClick={() => history.push("/parts")} active={part}>
        {t.parts.tab.first}
      </Button>

      <Button type="button"  active={set} onClick={() => history.push("/sets")}>
        {t.parts.tab.second}
      </Button>
    </Button.Group>

    <Divider className="part-divider mt-0 mb-8" />
  </div>
    // <div className="filters">
    //     <div className="text-right mb-5 pb-5 d-flex justify-content-between align-items-center views">
    //       <div className="list-view-option">
    //       <p className="single-view">
    //           <NavLink to="/parts">{t.parts.tab.first}</NavLink>
    //         </p>
    //         <p className="single-view">
    //           <NavLink to="/sets">
    //             {t.parts.tab.second}
    //             </NavLink>
    //         </p>
    //       </div>
    //     </div>
    //   </div>
  )
}

export default EmptyFilter